// host
export function host(url) {
  const host = url.replace(/^https?:\/\//, '').replace(/\/.*$/, '')
  const parts = host.split('.').slice(-3)
  if (parts[0] === 'www') parts.shift()
  return parts.join('.')
}

// etc
export function highlight(text, keyword) {
  return text.replace(
    new RegExp(
      `(${keyword
        .replace(/\s/g, '')
        .split('')
        .join('\\s*')})`,
      'gim'
    ),
    '<span class="highlight">$1</span>'
  )
}

// currency unit
export function comma(num) {
  let len, point, str

  num = num + ''
  point = num.length % 3
  len = num.length
  str = num.substring(0, point)

  while (point < len) {
    if (str != '') str += ','
    str += num.substring(point, point + 3)
    point += 3
  }
  return str
}

// time
export function timeAgo(time, self, now) {
  const between = (now || Date.now()) / 1000 - Number(time / 1000)

  if (between < 60) {
    return self.$i18n.t('common.timeAgo.justNow')
  } else if (between < 3600) {
    return self.$i18n.t('common.timeAgo.minute', { time: ~~(between / 60) })
  } else if (between < 86400) {
    return self.$i18n.t('common.timeAgo.hour', { time: ~~(between / 3600) })
  } else if (between < 2592000) {
    return self.$i18n.t('common.timeAgo.day', { time: ~~(between / 86400) })
  } else {
    return self.$moment(time).format('LL')
  }
}

export function getYYYYMMDD(data) {
  let time = new Date(data)
  return `${time.getFullYear()}년 ${time.getMonth() + 1}월 ${time.getDate()}일`
}

export function getHHMM(data) {
  let time = new Date(data)
  let hour =
    time.getHours() > 12
      ? `오후 ${setTwoDigits(time.getHours() - 12)}`
      : `오전 ${setTwoDigits(time.getHours())}`
  return `${hour} : ${setTwoDigits(time.getMinutes())}`
}

// file
export function getBytesToSize(bytes) {
  let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  if (bytes == 0) return '0 Byte'
  let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
}

//functions
function setTwoDigits(num) {
  return (num < 10 ? '0' : '') + num
}

// MOBILE -> WEB
export function transLabelWeb(value) {
  return value.replace(/MOBILE/g, 'WEB')
}

// 사업자 번호
export function formatBusinessNumber(input) {
  // 숫자 이외의 문자 제거
  const cleanedInput = input.replace(/\D/g, '')

  // 사업자번호 형식으로 변환
  let formattedNumber = ''
  if (cleanedInput.length === 10) {
    formattedNumber = `${cleanedInput.slice(0, 3)}-${cleanedInput.slice(3, 5)}-${cleanedInput.slice(
      5
    )}`
  } else {
    formattedNumber = cleanedInput
  }

  return formattedNumber
}
